const NAME_KEY = 'rowsprint.name';
const SETTINGS_KEY = 'rowsprint.ui';

export function loadName() {
  return localStorage.getItem(NAME_KEY) || '';
}

export function saveName(name) {
  localStorage.setItem(NAME_KEY, name);
}

export function sessionKey(code) {
  return `rowsprint.session.${String(code).toUpperCase()}`;
}

export function saveSession(code, session) {
  localStorage.setItem(sessionKey(code), JSON.stringify(session));
}

export function loadSession(code) {
  try {
    return JSON.parse(localStorage.getItem(sessionKey(code)) || 'null');
  } catch {
    return null;
  }
}

export function clearSession(code) {
  localStorage.removeItem(sessionKey(code));
}

export function loadUiSettings() {
  try {
    return { sound: false, reducedMotion: false, ...(JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}')) };
  } catch {
    return { sound: false, reducedMotion: false };
  }
}

export function saveUiSettings(settings) {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
}
